<template>
  <section>
    <el-table :data="paginationData">
      <el-table-column label="变更/维修类型" width="100px">
        <template slot-scope="scope">
          <!-- <a style="color: #175177;text-decoration: underline;" href="javascript:void(0)" @click="assetDetail(scope.row)">{{scope.row.number}}</a> -->
          <a style="color: #175177;text-decoration: underline;" href="javascript:void(0)" @click="assetDetail(scope.row)">{{
            scope.row.dealType==0?'信息变更':'维修记录' }}</a>
        </template>
      </el-table-column>

      <el-table-column prop="content" label="变更内容">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.content" placement="bottom">
            <span style="display:block;width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" v-html="scope.row.content"></span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="变更时间" width="120px">
      </el-table-column>

      <el-table-column label="变更人" width="140px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.user'></user-info>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <asset-change-detail></asset-change-detail>
    <asset-repair-detail></asset-repair-detail>

  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import AssetChangeDetail from './assetChangeDetail'
  import AssetRepairDetail from './assetRepairDetail'
  export default {
    props: ['assetId'],
    components: {
      AssetChangeDetail,
      AssetRepairDetail,
      UserInfo,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],
      }
    },
    mounted() {
      this.getLists()
    },
    methods: {
      // 显示详情
      assetDetail(row) {
        // 查询变革详情
        if (row.dealType == 0) {
          ajax.get('/asset/change/info/' + row.changeId, '', (res) => {
            let assetChangeDetail = {
              status: true,
              data: res.vo
            }
            this.$store.commit('set_assetChangeDetail', assetChangeDetail)
          })
        } else {
          ajax.get('/asset/repair/info/' + row.changeId, '', (res) => {
            let assetRepairDetail = {
              status: true,
              data: res.vo
            }
            this.$store.commit('set_assetRepairDetail', assetRepairDetail)
          })
        }
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        console.log(this.filterName)
        if (this.teamId || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]
            let _filterStatus = true
            if (this.teamId && _project.team && _project.team.id != this.teamId) {
              _filterStatus = false
            }
            if (!_project.team) {
              _filterStatus = false
            }
            if (_filterStatus) {
              if (_project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _project.leader.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1 ||
                _project.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_project)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/log/list', {
          assetId: this.assetId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'assetId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/logList.vue